/**
 * Constants
 */

// eslint-disable-next-line import/prefer-default-export
export const FALLBACK_PRODUCT_IMAGE = 'https://static.garmincdn.com/en/products/imagecomingsoon.gif';
